<p-dialog [draggable]="false" [blockScroll]="true" [resizable]="false" [(visible)]="luckyWinnerSubscribePopupVisibility"
    [style]="{ width:'550px', height: '500px' }" [contentStyle]="{ 'border-bottom-right-radius': '20px', 'border-bottom-left-radius': '20px',  'overflow': 'visible' }" position="center" [closable]="true" (onHide)="handlePopupClose('subscribe')">

    <div class="subscribe-promo-main">
        <div class="subscribe-promo-container">
            <div class="subscribe-promo-box subscribe-left-image-box">
                <img title="NutriGenic Get Started" decoding="async" src="assets/images/Dish-left-cut.png">
            </div>
            <div class="subscribe-promo-box subscribe-promo-text-box">

                <div class="promo-text">
                    <h1>Win a Year <br *ngIf="isDesktop">Of FREE FOOD<small>*</small></h1>
                
                    <h2>Yes! 365 Days. Totally Free.</h2>

                    <form id="subscribe-promo-form" [formGroup]="promoForm" (ngSubmit)="subscribePromo()" >
                        <div class="subscribe-promo-form-field">
                            
                            <input formControlName="fullName" placeholder="Full name" maxlength="60"/>
                            <div *ngIf="promoForm.get('fullName')?.invalid && promoForm.get('fullName')?.touched" class="validation-error">
                                <span *ngIf="promoForm.get('fullName')?.errors?.['required']">Full name is required.</span>
                                <span *ngIf="promoForm.get('fullName')?.errors?.['maxlength']">Full name cannot exceed 60 characters.</span>
                                <span *ngIf="promoForm.get('fullName')?.errors?.['pattern']">Full name can only contain letters, apostrophes, and hyphens.</span>
                            </div>
                        </div>

                        <div class="subscribe-promo-form-field">
                            
                            <input formControlName="email" placeholder="Email" maxlength="60"/>
                            <div *ngIf="promoForm.get('email')?.invalid && promoForm.get('email')?.touched" class="validation-error">
                                <span *ngIf="promoForm.get('email')?.errors?.['required']">Email is required.</span>
                                <span *ngIf="promoForm.get('email')?.errors?.['email']">Enter a valid email.</span>
                                <span *ngIf="promoForm.get('email')?.errors?.['maxlength']">Email cannot exceed 60 characters.</span>
                            </div>
                        </div>
                        <div class="subscribe-promo-form-field">
                            
                            <input formControlName="phoneNumber" placeholder="Phone Number" maxlength="20"/>
                            <div *ngIf="promoForm.get('phoneNumber')?.invalid && promoForm.get('phoneNumber')?.touched" class="validation-error">
                                <span *ngIf="promoForm.get('phoneNumber')?.errors?.['required']">Phone number is required.</span>
                                <span *ngIf="promoForm.get('phoneNumber')?.errors?.['maxlength']">Phone number cannot exceed 20 digits.</span>
                                <span *ngIf="promoForm.get('phoneNumber')?.errors?.['pattern']">Phone number can only contain numbers and + symbol.</span>
                            </div>
                        </div>
                        <div>
                            <button type="submit">Get Started</button>
                        </div>
                    </form>
                </div>
            </div>
            <div class="subscribe-promo-box subscribe-right-image-box">
                <img alt="NutriGenic Get Started" title="NutriGenic Get Started" decoding="async" src="assets/images/Dish-right-cut.png">
            </div>
        </div>
        <a href="/terms" class="terms-and-conditions">*Terms And Conditions Apply</a>
    </div>
    
</p-dialog>


<!-- Second Popup -->


<p-dialog [draggable]="false" [blockScroll]="true" [resizable]="false" [(visible)]="luckyWinnerOrderNowPopupVisibility"
    [style]="{ width:'550px' }" [contentStyle]="{ 'border-bottom-right-radius': '20px', 'border-bottom-left-radius': '20px', 'overflow-x': 'hidden' }" position="center" [closable]="true" (onHide)="handlePopupClose('orderNow')">


    <div>
        <div class="promo-box">
            <div class="lucky-winner-order-now-image-box">
                <img alt="NutriGenic Get Started"
                        title="NutriGenic Get Started" decoding="async"
                        src="assets/images/promo-image-user-phone.png">
            </div>
            <div class="promo-text">
                <h1>Make the Smart Switch</h1>
            </div>
            <div class="promo-text">
                <h2>
                    Order now with code <span>REFUEL</span><br> 
                    One Lucky Customer <span>Will Get a Year of FREE Food</span>
                </h2>
            </div>
            <div class="web-center" style="margin-top: 20px !important;">
                <app-orange-button text="Order Now"  (action)="goToPlan()" />
            </div>
        </div>
    </div>

</p-dialog>